import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Constellation from './components/Constellation';
import Dashboard from './views/Dashboard';
import Insights from './views/Insights';
import Settings from './views/Settings';
import Demo from './views/Demo';

function App() {
  return (
    <Router>
      <div className="flex flex-col md:flex-row h-screen w-full bg-ink-900 text-gray-100 overflow-hidden relative">
        <Constellation />
        
        <div className="flex flex-col md:flex-row w-full h-full z-10 relative">
          <Navigation />
          
          <main className="flex-1 relative h-[calc(100vh-70px)] md:h-full overflow-hidden">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;